import { render, staticRenderFns } from "./operationLog.vue?vue&type=template&id=50c1b437&scoped=true"
import script from "./operationLog.vue?vue&type=script&lang=js"
export * from "./operationLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c1b437",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/dev-node-01/workspace/test-flight/tinggo/tinggo-vue-12765/server_app_code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50c1b437')) {
      api.createRecord('50c1b437', component.options)
    } else {
      api.reload('50c1b437', component.options)
    }
    module.hot.accept("./operationLog.vue?vue&type=template&id=50c1b437&scoped=true", function () {
      api.rerender('50c1b437', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/risk/operationLog.vue"
export default component.exports